// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"f08ef35e","92":"102e6189","125":"3609198a","129":"f33be779","345":"e64841e8","628":"a13d9482","672":"40c0fec0"}[chunkId] + ".chunk.js";
};